import { sendRequest } from "./api";

export interface IUserSettings {
    lastName: string,
    firstName: string,
    customAvatarUrl?: string
}

const route = 'user';

export const getUserSettings = () => {
    return sendRequest(route, 'GET', undefined, '');
}

export const putUserSettings = (data: IUserSettings) => {
    return sendRequest(route, 'PUT', data, '');
}